var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNp = function SvgNp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 12,
    fill: "none",
    viewBox: "0 0 21 15"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5dc99f6f-b28c-4af9-a961-0be09b6e2bf5a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "4d1c1926-71a8-41e4-ba1b-2d2ea19d9e41b",
    width: 21,
    height: 15,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 0H2a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h17a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#4d1c1926-71a8-41e4-ba1b-2d2ea19d9e41b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#003495",
    fillRule: "evenodd",
    d: "m0 0 13 8H6l7 7H0z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DF0A37",
    fillRule: "evenodd",
    d: "m1 2 8 5H3l7 7H1.998C1.448 14 1 13.544 1 12.998z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M4.915 5A.43.43 0 0 1 5 5.25c0 .414-.672.75-1.5.75S2 5.664 2 5.25A.43.43 0 0 1 2.085 5c.206.146.762.25 1.415.25S4.71 5.146 4.915 5",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeOpacity: 0.1,
    d: "M1.762 1.303C1.065.86.5 1.175.5 1.998v11.004c0 .827.668 1.498 1.503 1.498H12l-7-7h6.5z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "5dc99f6f-b28c-4af9-a961-0be09b6e2bf5a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h13v15H0z"
  })))));
};
export default SvgNp;